export type FlightProgram = {
  name: string;
  org: string;
  orgUrl: string;
  /** Short program status line, e.g. flight status of the hardware. */
  status: string;
  /** What Divij's work contributed to the program. */
  description: string;
  icon: "starship" | "capsule";
};

export const FLIGHT_HERITAGE: FlightProgram[] = [
  {
    name: "Starship",
    org: "SpaceX",
    orgUrl: "https://www.spacex.com/vehicles/starship/",
    status: "In development",
    description:
      "Launch pad fluids software supporting ground systems through launch operations.",
    icon: "starship",
  },
  {
    name: "W-Series Spacecraft",
    org: "Varda Space Industries",
    orgUrl: "https://varda.com",
    status: "W-5 flown, W-10+ in build",
    description:
      "Program scheduling and SpaceX rideshare deliverables spanning vehicle build through reentry and recovery.",
    icon: "capsule",
  },
];
